import { useLingui } from '@lingui/react/macro';

import { UniqueArticleSearchSelect } from '@/components/UniqueArticleSearchSelect';
import { useUpdateArticle } from '@/models/article';

import { useArticleContext } from '../../contexts/ArticleContext';

import { useProductAndUniqueArticleInputs } from './useProductAndUniqueArticleInputs';

export const UniqueArticle = () => {
  const { t } = useLingui();

  const { request, article, errors } = useArticleContext();
  const { uniqueArticleInput, errorMessage } = useProductAndUniqueArticleInputs();

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  const updateUniqueArticle = (uniqueArticle: { id: string } | null) => {
    if (uniqueArticle === null && !!article.uniqueArticle) {
      updateArticle({
        data: {
          uniqueArticleId: null,
        },
        optimisticData: {
          uniqueArticle: null,
          productId: null,
          product: null,
          productAttributeValues: [],
          data: {},
        },
      });
    } else if (uniqueArticle && article.uniqueArticle?.id !== uniqueArticle.id) {
      updateArticle({
        data: {
          uniqueArticleId: uniqueArticle.id,
        },
      });
    }
  };

  return (
    <UniqueArticleSearchSelect
      labelProps={{
        label: t({ id: 'article.form.unique-article.label', message: 'Serial number' }),
        tooltip: t({
          id: 'article.form.unique-article.tooltip',
          message: 'The serial number is a unique identifier for each item',
        }),
        optional: uniqueArticleInput.optional && !uniqueArticleInput.disabled,
      }}
      ariaLabel={t({ id: 'article.form.unique-article.label', message: 'Serial number' })}
      placeholder={t({
        id: 'article.form.unique-article.placeholder',
        message: 'Search item by serial number',
      })}
      value={article.uniqueArticle}
      onChange={updateUniqueArticle}
      brandId={article.brandId ?? undefined}
      isDisabled={uniqueArticleInput.disabled}
      tooltipLabel={uniqueArticleInput.disabledTooltipMessage}
      error={errors.details?.product && !uniqueArticleInput.optional ? errorMessage : undefined}
    />
  );
};
